// File di configurazione dell'applicazione

// Configurazione dell'API
const getApiBaseUrl = () => {
    if (import.meta.env.VITE_API_BASE_URL) return import.meta.env.VITE_API_BASE_URL;
    if (import.meta.env.REACT_APP_API_BASE_URL) return import.meta.env.REACT_APP_API_BASE_URL;
    // Production default
    return 'https://recupmanager.studiohard.it/api';
};

export const API_BASE_URL = getApiBaseUrl();

// Configurazione API HealthNET
export const HEALTHNET_API_CONFIG = {
    baseUrl: process.env.REACT_APP_HEALTHNET_API_URL || 'http://localhost:5000/api',
    clientId: process.env.REACT_APP_HEALTHNET_CLIENT_ID || 'client',
    clientSecret: process.env.REACT_APP_HEALTHNET_CLIENT_SECRET || '754fee8a10713ae8c335434a5f859ea1b00d17ee750d0c51957e9463d7776d0f',
    timeout: 30000,
    retryAttempts: 3,
    retryDelay: 1000
};

// Configurazione delle chiavi di sicurezza
export const SECRET_KEY = process.env.REACT_APP_SECRET_KEY || 'your-secret-key-here';

// Configurazione delle impostazioni predefinite
export const DEFAULT_SETTINGS = {
    theme: 'light',
    language: 'it',
    notifications: true
};

// Configurazione delle route
export const ROUTES = {
    HOME: '/',
    LOGIN: '/login',
    REGISTER: '/register',
    DASHBOARD: '/dashboard',
    EXECUTION_UNITS: '/execution-units',
    DIARIES: '/diaries',
    BOOKINGS: '/bookings',
    NOTIFICATIONS: '/notifications',
    USERS: '/users',
    SYNC: '/sync',
    SETTINGS: '/settings'
};

// Configurazione dei permessi
export const PERMISSIONS = {
    READ: 'read',
    WRITE: 'write',
    DELETE: 'delete',
    ADMIN: 'admin'
};

// Configurazione dei ruoli
export const ROLES = {
    USER: 'user',
    ADMIN: 'admin',
    SUPER_ADMIN: 'super_admin'
};
